import React from 'react';
import jwtDecode from 'jwt-decode';
import { useAccessTokenStore } from 'Hooks/zustand/useAccessTokenStore';
import { trackEvent, EventTypes, EventNames } from '@brighterion/insights';
import { AuthService } from '../../../services/authService';

declare global {
    namespace JSX {
        interface IntrinsicElements {
            'tableau-viz': TableauAttributes;
        }
        interface TableauAttributes {
            id: string;
            src: string;
            token: string;
            toolbar?: 'top' | 'bottom' | 'hidden';
            height?: React.CSSProperties['height'];
            width?: React.CSSProperties['width'];
            onFirstInteractive?: (event: any) => void;
        }
    }
}

interface Props {
    report: TableauReportConfig;
}

const TableauContainer = ({ report }: Props) => {
    const { accessToken } = useAccessTokenStore();
    const jwt = jwtDecode<JWT>(accessToken!);

    const refreshToken = async () => {
        const tableauTokenDecoded = jwtDecode<TableauToken>(jwt.tableauToken);
        const tableauTokenExpiry = tableauTokenDecoded.exp * 1000;
        const currentTime = Date.now();
        // add 2 seconds to avoid edge cases
        if (currentTime + 2000 >= tableauTokenExpiry) {
            await AuthService?.refreshAccessToken();
            const token = await AuthService?.getAccessToken();
            useAccessTokenStore.setState({ accessToken: token });
        }
    };

    React.useEffect(() => {
        trackEvent({
            eventType: EventTypes.track,
            eventName: EventNames.click,
            payload: {
                clickIdentifier: 'Manage Reports - View Configured Dashboard',
                text: 'View Configured Dashboard'
            }
        });
        refreshToken();
    }, []);
    return <tableau-viz id='tableauViz' src={report.url} token={jwt.tableauToken} toolbar='hidden' height='888' />;
};

export default TableauContainer;
